
<div id="payment-wrapper" class="wrapper text-center w-100 h-100">

  <app-thankyou-success-head [config]="{order: order}"></app-thankyou-success-head>

  <!-- Image -->
  <div class="image-container">
    <img loading="lazy" data-src="/assets/images/sip/kids.png" />
  </div>

  <!-- Quiz info -->
  <div class="quiz-info">
    <div class="title">Boost your contribution by another <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>{{prizeAmount}}</div>
    <div class="subtitle">
      Add another <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon> {{prizeAmount}} and increase your contribution amount by playing the challenging Ketto Quiz!
    </div>
  </div>

  <!-- Quiz footer -->
  <div class="quiz-footer">
    <span class="redirect">Redirecting to quiz in </span> 10 seconds...
    <button type="button" mat-raised-button (click)="takeQuiz()">Take The Quiz</button>

    <!-- Skip quiz -->
    <div class="skip">
      <a (click)="skipQuiz()">Skip</a>
    </div>
  </div>
</div>
